import { render, staticRenderFns } from "./RDIModal.vue?vue&type=template&id=0c64ef55&scoped=true"
import script from "./RDIModal.vue?vue&type=script&lang=js"
export * from "./RDIModal.vue?vue&type=script&lang=js"
import style0 from "./RDIModal.vue?vue&type=style&index=0&id=0c64ef55&prod&scoped=true&lang=css"
import style1 from "./RDIModal.vue?vue&type=style&index=1&id=0c64ef55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c64ef55",
  null
  
)

export default component.exports